import { gql } from '@apollo/client';

const getBookingOutlet = gql`
  query GetOutlet(
    $getOutletId: ID!
    $outletIdType: outletIDType!
    $additionalFilters: ProductFilters
  ) {
    getOutlet(
      outletIDType: $outletIdType
      additionalFilters: $additionalFilters
      id: $getOutletId
    ) {
      id
      name
      code
      legacyCode
      category
      partnerBrand {
        id
        partnerIntegrationData {
          partnerIntegrationID
        }
      }
      location {
        timezone
        code
        name
        terminal
      }
      products {
        id
        name
        category
        partnerIntegrationData {
          accessPeriod
          bookingFlowType
          bookingMaxPeriodAllowed
          bookingMinPeriodAllowed
          cancellationPeriodAllowed
          partnerIntegrationID
          maxGuests {
            adult {
              isChargeable
              isPartySizeImpacted
              value
            }
            children {
              isChargeable
              value
              isPartySizeImpacted
            }
            infant {
              isChargeable
              value
              isPartySizeImpacted
            }
            partySize
            senior {
              isChargeable
              value
              isPartySizeImpacted
            }
          }
          timeSlotPeriod
          partnerProductID
          stripeProductID
        }
        salePrices {
          programme
          salePrice
          salePriceCurrency
        }
        status
        accessType
      }
      accessTimes {
        accessHours {
          monday {
            startTime
            endTime
          }
          tuesday {
            startTime
            endTime
          }
          wednesday {
            startTime
            endTime
          }
          thursday {
            startTime
            endTime
          }
          friday {
            startTime
            endTime
          }
          saturday {
            startTime
            endTime
          }
          sunday {
            startTime
            endTime
          }
        }
      }
      media {
        mainImage {
          asset {
            url
          }
        }
      }
    }
  }
`;
export default getBookingOutlet;
